import CloakFetcher from 'cloak-auth/src/Client/CloakFetcher';
import { InstanceDTO } from 'gen/model';
import useSWR from 'swr';

import DescriptionModal from 'kerberus-components/src/Components/Modals/DescriptionModal';
import { Advertised, InstanceDescription, InstanceInfo } from 'kerberus-components/src/Types/AuthServer';

interface InstanceMapModalProps {
    handleClose: () => void;
    instance: InstanceDTO;
    open: boolean;
}

export default function InstanceMapModal({ handleClose, instance, open }: Readonly<InstanceMapModalProps>) {
    const { data: instanceDescription } = useSWR<InstanceDescription>(
        instance.domain ? ['tasks/instance_description', instance.id] : null,
        (route: string) => CloakFetcher(route, instance.domain),
    );
    const { data: instanceInfo } = useSWR<InstanceInfo>(
        instance.domain ? ['tasks/instance_info', instance.id] : null,
        (route: string) => CloakFetcher(route, instance.domain),
    );
    const { data: advertised } = useSWR<Advertised>(
        instance.domain ? ['users/advertised', instance.id] : null,
        (route: string) => CloakFetcher(route, instance.domain),
    );

    return (
        <DescriptionModal
            advertised={advertised}
            domain={instance.domain}
            excludedKeys={['id', 'public_operator']}
            instanceDescription={instanceDescription}
            instanceId={instance.id}
            instanceInfo={instanceInfo}
            noMap
            onClose={handleClose}
            open={open}
            showUserAmount={false}
            tabs
        />
    );
}
